import React, { useEffect, useState } from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import integrationsService from '../../services/integrationsService';
import { apiErrorMessage } from '../../utils/apiError';
import ConfirmModal from './ConfirmModal';
import './CrawlerTestModal.css';

// THE CRAWLER SOURCE'S TEST — a dry run of the implementation's configured url (POST /pipelines/{id}/test-crawler):
// its config, robots.txt, what a crawl would find, the start page, and the /content route the content goes through.
// Nothing is crawled, queued or written. Opened from the Test button on a Crawler source's System box
// (ImplementationBoard), as the OXI / Pegasus / OHIP / MCP suites are for theirs.
export default function CrawlerTestModal({ integrationId, implementation, source, onClose }) {
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [running, setRunning] = useState(false);

    const run = async () => {
        setRunning(true); setError(null);
        try {
            setResult(await integrationsService.testCrawler(integrationId, {
                implementationId: implementation && implementation.id, nodeId: source.id }));
        } catch (e) {
            setError(apiErrorMessage(e, 'The test could not be run.'));
        } finally {
            setRunning(false);
        }
    };
    // Run on open — there is nothing to choose first.
    // eslint-disable-next-line
    useEffect(() => { run(); }, [source && source.id]);

    return (
        <ConfirmModal
            title={`Test ${source.system_name || 'the crawler'}`}
            confirmLabel={running ? 'Running…' : 'Run again'}
            confirmDisabled={running}
            onConfirm={run}
            cancelLabel="Close"
            closeOnBackdrop={false}
            onCancel={onClose}
            wide
        >
            <p className="cm-message">
                A dry run of the site {implementation ? <>configured for <strong>{implementation.hotelname || implementation.name}</strong></> : 'configured'}:
                the steps a crawl starts with. Nothing is crawled, queued or written.
            </p>
            {error && <div className="os-msg os-msg-error">{error}</div>}
            {running && !result && <p className="cm-message">Running…</p>}
            {result && (
                <ul className="crawler-test-steps">
                    {result.steps.map(s => (
                        <li key={s.name} className={s.ok ? 'is-ok' : 'is-fail'}>
                            {s.ok ? <CheckCircle2 size={15} /> : <XCircle size={15} />}
                            <strong>{s.name}</strong> <span>{s.detail}</span>
                        </li>
                    ))}
                </ul>
            )}
        </ConfirmModal>
    );
}
